module.exports = __webpack_public_path__ + "img/DISCOUNT.e3f95d99.svg";